import React from "react"
import PropTypes from 'prop-types'
import {FieldAutomationActionFormProps} from "../../../render/automation-action-form";
import EditableInput from "./inline-editable/input-component";



const debug = false
// const debug = "InputActionForm"

export default class FieldString_AutomationActionForm extends React.Component<any,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', '')
        }
    }

    onChangeContentValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state.validationType, this.state.value)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <React.Fragment>
                <div className="flex-row-left-center">
                    <div className={labelClasses}>to</div>
                    <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-300 h-36 p-l-10 p-r-10"
                                   inputClassName   = "ui5-txt-default"
                                   value            = {this.state.toValue}
                                   placeholder      = "Field value"
                                   onChange         = {this.onChangeContentValue}/>
                </div>
            </React.Fragment>
        )
    }

}